if (!customElements.get('quick-add-modal')) {
	customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
		constructor() {
			super();
			this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
		}

		hide(preventFocus = false) {
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
			this.modalContent.innerHTML = '';

			if (preventFocus) this.openedBy = null;
			super.hide();
		}

		show(opener) {
			opener.setAttribute('aria-disabled', true);
			opener.classList.add('loading');

			if (opener.querySelector('.loading-overlay__spinner')) {
				opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
			}

			// Capturar pré-seleção (se houver)
			const preselectedColor = opener?.dataset.preselectedColor;
			const preselectedSize = opener?.dataset.preselectedSize;
			const preselectedOption = opener?.dataset.preselectedOption;

			// Mostrar loading skeleton
			this.showLoadingSkeleton();

			ShopifyAPI.fetchSection(opener.getAttribute('data-product-url'), '[id^="MainProduct-"]')
				.then((productElement) => {
					this.productElement = productElement;
					this.preventDuplicatedIDs();
					this.removeDOMElements();
					this.setInnerHTML(this.modalContent, this.productElement.innerHTML, opener);

					if (window.Shopify && Shopify.PaymentButton) {
						Shopify.PaymentButton.init();
					}

					if (window.ProductModel) window.ProductModel.loadShopifyXR();

					this.removeGalleryListSemantic();
					this.updateImageSizes();
					this.preventVariantURLSwitching();

					// Esconder loading skeleton
					this.hideLoadingSkeleton();

					// Animar entrada (se GSAP disponível)
					if (window.gsap) {
						gsap.from(this.querySelector('.quick-add-modal__content'), {
							opacity: 0,
							y: 20,
							duration: 0.3,
							ease: 'power2.out'
						});
					}

					super.show(opener);

					// Pré-selecionar variantes após modal abrir
					if (preselectedColor || preselectedSize || preselectedOption) {
						setTimeout(() => {
							if (preselectedColor) this.preselectOption('color', preselectedColor);
							if (preselectedSize) this.preselectOption('size', preselectedSize);
							if (preselectedOption) this.preselectOption('option', preselectedOption);

							// Limpar dataset após usar
							delete opener.dataset.preselectedColor;
							delete opener.dataset.preselectedSize;
							delete opener.dataset.preselectedOption;
						}, 150);
					}

					// Auto-focus primeiro input
					this.focusFirstInput();
				})
				.finally(() => {
					opener.removeAttribute('aria-disabled');
					opener.classList.remove('loading');

					if (opener.querySelector('.loading-overlay__spinner')) {
						opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
					}

					var slider = new Swiper('.quick-add-modal .js-media-list', {
						slidesPerView: 1,
						autoHeight: true,
						navigation: {
							nextEl: '.swiper-btn--next',
							prevEl: '.swiper-btn--prev',
						},
						pagination: {
							el: ".swiper-pagination",
							clickable: true,
						},
						on: {
							slideChange: function () {
								window.pauseAllMedia();
							}
						}
					});
				});
		}

		setInnerHTML(element, html, opener) {
			element.innerHTML = html;

			// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
			element.querySelectorAll('script').forEach(oldScriptTag => {
				const newScriptTag = document.createElement('script');
				Array.from(oldScriptTag.attributes).forEach(attribute => {
					newScriptTag.setAttribute(attribute.name, attribute.value)
				});
				newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
				oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
			});

			// Read more button
			const moreBtn = document.createElement('a');
			moreBtn.textContent = `${theme.quickviewMore}`;
			moreBtn.setAttribute('href', opener.getAttribute('data-product-url'));
			moreBtn.setAttribute('class', 'product__read-more button--simple full-unstyled-link h6');
			element.querySelector('.product__info-container').appendChild(moreBtn);
		}

		removeDOMElements() {
			const pickupAvailability = this.productElement.querySelector('pickup-availability');
			if (pickupAvailability) pickupAvailability.remove();

			const productModal = this.productElement.querySelector('product-modal');
			if (productModal) productModal.remove();

			const gift = this.productElement.querySelector('.customer');
			if (gift) gift.remove();
		}

		preventDuplicatedIDs() {
			const sectionId = this.productElement.dataset.section;
			this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
			this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
				variantSelect.dataset.originalSection = sectionId;
			});
		}

		preventVariantURLSwitching() {
			if (this.modalContent.querySelector('variant-radios,variant-selects')) {
				this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
			}
		}

		removeGalleryListSemantic() {
			const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
			if (!galleryList) return;

			galleryList.setAttribute('role', 'presentation');
			galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
		}

		updateImageSizes() {
			const product = this.modalContent.querySelector('.product');
			const desktopColumns = product.classList.contains('product--columns');
			if (!desktopColumns) return;

			const mediaImages = product.querySelectorAll('.product__media img');
			if (!mediaImages.length) return;

			let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

			if (product.classList.contains('product--medium')) {
				mediaImageSizes = mediaImageSizes.replace('715px', '605px');
			} else if (product.classList.contains('product--small')) {
				mediaImageSizes = mediaImageSizes.replace('715px', '495px');
			}

			mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
		}

		/**
		 * Mostra loading skeleton enquanto carrega o produto
		 */
		showLoadingSkeleton() {
			if (!this.modalContent) return;

			const skeleton = `
				<div class="loading-overlay loading-overlay--absolute">
					<div class="loading__spinner">
						<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
						</svg>
					</div>
				</div>
			`;
			this.modalContent.innerHTML = skeleton;
		}

		/**
		 * Esconde loading skeleton
		 */
		hideLoadingSkeleton() {
			const overlay = this.querySelector('.loading-overlay');
			if (overlay) overlay.remove();
		}

		/**
		 * Pré-seleciona uma opção de variante
		 * @param {string} type - Tipo da opção ('color', 'size', etc)
		 * @param {string} value - Valor a ser selecionado
		 */
		preselectOption(type, value) {
			const variantContainer = this.modalContent.querySelector('variant-selects, variant-radios');
			if (!variantContainer) return;

			// Buscar input/option com o valor exato
			const inputs = variantContainer.querySelectorAll('input[type="radio"], select option');

			for (const input of inputs) {
				if (input.value === value) {
					if (input.type === 'radio') {
						input.checked = true;
						input.dispatchEvent(new Event('change', { bubbles: true }));
					} else if (input.tagName === 'OPTION') {
						input.selected = true;
						input.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
					}
					console.log(`[QuickAddModal] Preselected ${type}:`, value);
					break;
				}
			}
		}

		/**
		 * Foca o primeiro input de variante para acessibilidade
		 */
		focusFirstInput() {
			const firstInput = this.modalContent.querySelector('variant-selects select, variant-radios input[type="radio"]:first-of-type');
			if (firstInput) {
				setTimeout(() => firstInput.focus(), 200);
			}
		}
	});
}
